import { useMemo } from "react";
import { Link } from "react-router-dom";
import { Landmark } from "lucide-react";

import { businessApi } from "../../services/api";
import GovernmentNumbersPanel from "../pages/hr/components/GovernmentNumbersPanel";
import { EMPLOYER_NUMBER_LABELS } from "../pages/hr/statutoryView";

// Business Settings > Government registrations (CD-S1). The business's own numbers with SSS, PhilHealth, Pag-IBIG
// and the BIR. Only the owner sees or changes them; payroll staff see whether each one is recorded.

export default function BusinessGovernmentRegistrations() {
  const adapter = useMemo(() => ({
    load: () => businessApi.getBusinessRegistrations(),
    reveal: (agency) => businessApi.revealBusinessRegistration(agency),
    save: (changes) => businessApi.updateBusinessRegistrations(changes),
  }), []);

  return (
    <div className="space-y-4">
      <GovernmentNumbersPanel
        adapter={adapter}
        labels={EMPLOYER_NUMBER_LABELS}
        icon={Landmark}
        title="Government registrations"
        subtitle="The numbers your business holds with each agency. Apparify records them; it does not file or pay anything for you."
        privacyNote="Numbers are hidden by default. Only you, the owner, can show or change them, and each time is recorded."
        readOnlyNote="Only the business owner can see or change these numbers."
        restrictedText="Only the business owner can open the government registrations."
        suggestionFor={(item, data) => (item.agency === "BIR" && data?.suggestedBusinessTin
          ? { label: "Use the TIN from your business application", value: data.suggestedBusinessTin }
          : null)}
      />
      <p className="text-sm text-neutral-600 dark:text-neutral-400">
        Looking for the contribution and tax rules?{" "}
        <Link to="/business/hr/settings/government" className="font-medium text-neutral-900 underline underline-offset-2 dark:text-neutral-100">
          See the government rules Apparify uses
        </Link>
      </p>
    </div>
  );
}
